import * as XLSX from 'xlsx'

export const fmtDate = value => {
  if (!value) return ''
  const d = new Date(value)
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const fmtQty = v => {
  const n = Number(v)
  return Number.isNaN(n) ? '' : n.toLocaleString('de-DE', { maximumFractionDigits: 2 })
}

// t = the component's $t, so headers follow the UI language.
export const exportBackorderXlsx = (results, t) => {
  const c = k => t(`delivery.backorder.cols.${k}`)
  const x = k => t(`delivery.backorder.exportCols.${k}`)
  const rows = results.map(r => ({
    [c('article')]: r.item_sku,
    [x('name')]: r.name,
    [c('openQty')]: Number(r.open_qty),
    [c('added')]: fmtDate(r.added_date),
    [c('age')]: r.age_days,
    [c('vorStock')]: Number(r.supplier_stock),
    [x('vorStockUpdated')]: fmtDate(r.supplier_stock_updated),
    [c('vorLeadTime')]: r.supplier_lead_days || '',
    [c('ownStock')]: Number(r.own_stock),
    [c('otherSuppliers')]: r.other_suppliers || '',
    [c('waitingOrders')]: r.waiting_orders,
    [x('oldestWaitingOrder')]: r.oldest_waiting_order_no || '',
    [c('lbDate')]: fmtDate(r.delivery_date),
    [c('note')]: r.note || '',
  }))
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), 'Backorder')
  XLSX.writeFile(wb, 'DeliveryDate_Backorder.xlsx')
}
